import theme from 'src/theme'
import styled from 'styled-components'

const breakpoint = 'extraLarge'
const gutter = theme.breakpoints[breakpoint].gutter

const Sidebar = styled.aside`
	position: sticky;
	top: 152px;
	padding: 0;
	max-height: calc(100vh - 152px);
	overflow-x: auto;

	display: none;

	${p => p.theme.above(breakpoint)`
		display: block;
	`}
`

export const LeftSidebar = styled(Sidebar)`
	left: 0;
	margin: 0px ${gutter}px 0px 0px;
`

export const RightSidebar = styled(Sidebar)`
	left: auto;
	right: 0;
	border-left: 1px solid var(--color-lighterGrey);
	margin: 0px 16px 0px ${gutter}px;
	overflow-x: hidden;
	width: 250px;
	flex: none;
	word-break: break-word;
`

export const FakeRightSidebar = styled.div`
	width: 88px;

	display: none;

	${p => p.theme.above(breakpoint)`
		display: block;
	`}
`
